import React, { useState } from 'react';
import axios from '../api/axiosInstance';
import Cookies from 'js-cookie';

const AdminResumeUpload = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');
  const [previewURL, setPreviewURL] = useState('');
  const token = Cookies.get('token');
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setPreviewURL(URL.createObjectURL(selectedFile));
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      return setMessage('Please select a PDF to upload.');
    }

    const formData = new FormData();
    formData.append('resume', file);

    try {
      const res = await axios.post('/admin/upload-resume', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`,
        },
        withCredentials: true,
      });

      setMessage(res.data.message);
    } catch (error) {
      console.error(error);
      setMessage(error.response?.data?.error || 'Upload failed');
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white flex flex-col justify-center items-center px-4">
      <h1 className="text-2xl font-bold mb-4">Upload Resume (PDF)</h1>
      <form
        onSubmit={handleUpload}
        className="bg-gray-800 p-6 rounded-xl w-full max-w-md shadow-lg"
      >
        <input
          type="file"
          accept="application/pdf"
          onChange={handleFileChange}
          className="block w-full mb-4"
        />

        {previewURL && (
          <iframe
            src={previewURL}
            title="PDF Preview"
            className="w-full h-64 mb-4 border border-gray-600"
          />
        )}

        <button
          type="submit"
          className="w-full bg-blue-600 py-2 rounded hover:bg-blue-700 transition font-semibold"
        >
          Upload Resume
        </button>

        {message && <p className="mt-4 text-center text-sm">{message}</p>}
      </form>
    </div>
  );
};

export default AdminResumeUpload;
